'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enhance = exports.Layout = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Layout = exports.Layout = function Layout(_ref) {
  var input = _ref.input,
      button = _ref.button,
      text = _ref.text;
  return _react2.default.createElement(
    'div',
    null,
    input,
    button,
    text
  );
};

var enhance = exports.enhance = (0, _recompose.compose)((0, _recompose.setDisplayName)('Layout'), (0, _recompose.setPropTypes)({
  input: _propTypes2.default.node.isRequired,
  button: _propTypes2.default.node.isRequired,
  text: _propTypes2.default.node.isRequired
}));

exports.default = enhance(Layout);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@team-griffin/react-file-input/lib/Layout.js
// module id = 485
// module chunks = 0